// src/components/Status/StatusListHeader.jsx
import React from 'react';
import './StatusListHeader.css';

function StatusListHeader() {
  return (
    <div className="status-list-header">
      {/* 상태 (맨 왼쪽 뱃지 공간 확보) */}
      <div className="header-item status-col">상태</div>
      
      <div className="header-item machine-col">장비명</div>
      <div className="header-item job-col">작업명</div>
      <div className="header-item material-col">소재종류</div>
      <div className="header-item shape-col">소재모양</div>
      <div className="header-item size-col">소재크기</div>
      <div className="header-item length-col">절단길이</div>
      <div className="header-item count-col">작업수량</div>
      <div className="header-item time-col">남은시간</div>
      
      {/* 우측 메시지 영역 */}
      <div className="header-item message-col">메시지</div>
    </div>
  );
}

export default StatusListHeader;